<template>
  <div class="d-flex mb-3">
    <!-- Right Section: Form Content -->
    <div class="d-flex flex-column justify-content-center align-items-center w-100">
      <div class="border-0 text-dark w-75 p-4 overflow-auto">
        <!-- Όροι και Προϋποθέσεις Χρήσης Πλατφόρμας -->
        <h1 class="py-3">Όροι και Προϋποθέσεις Χρήσης Πλατφόρμας</h1>
        <ol>
          <li>
            <b>Εισαγωγή:</b> Οι παρόντες Όροι και Προϋποθέσεις διέπουν τη χρήση της πλατφόρμας Διαχείριση Ηλεκτρονικού Εισιτηρίου. Με την πρόσβαση ή χρήση της Πλατφόρμας, αποδέχεστε ανεπιφύλακτα τους παρόντες Όρους.
          </li>
          <li>
            <b>Δικαίωμα Χρήσης:</b> Η χρήση της Πλατφόρμας επιτρέπεται μόνο σε άτομα άνω των 18 ετών ή σε ανηλίκους με τη συγκατάθεση κηδεμόνα. Ο χρήστης δηλώνει ότι παρέχει ακριβή και ενημερωμένα στοιχεία.
          </li>
          <li>
            <b>Λογαριασμός Χρήστη:</b>
            <ul>
              <li>Ο χρήστης είναι υπεύθυνος για τη διατήρηση της εμπιστευτικότητας των στοιχείων σύνδεσης.</li>
              <li>Οποιαδήποτε δραστηριότητα μέσω του λογαριασμού θεωρείται ότι πραγματοποιείται από τον ίδιο.</li>
              <li>Η Πλατφόρμα διατηρεί το δικαίωμα αναστολής ή διαγραφής λογαριασμού σε περίπτωση παραβίασης των Όρων.</li>
            </ul>
          </li>
          <li>
            <b>Επιτρεπόμενη Χρήση:</b> Απαγορεύεται η χρήση της Πλατφόρμας για:
            <ul>
              <li>Παράνομες δραστηριότητες</li>
              <li>Παραβίαση δικαιωμάτων τρίτων</li>
              <li>Μετάδοση κακόβουλου λογισμικού</li>
              <li>Παρενόχληση ή δυσφημιστικό περιεχόμενο</li>
            </ul>
          </li>
          <li>
            <b>Περιεχόμενο Χρηστών:</b> Ο χρήστης διατηρεί τα δικαιώματα στο περιεχόμενο που ανεβάζει, αλλά παρέχει στην Πλατφόρμα μη αποκλειστική άδεια χρήσης για τη λειτουργία και προώθηση των υπηρεσιών. Η Πλατφόρμα μπορεί να αφαιρεί περιεχόμενο που παραβιάζει τους Όρους ή τη νομοθεσία.
          </li>
          <li>
            <b>Πνευματική Ιδιοκτησία:</b> Όλο το περιεχόμενο της Πλατφόρμας (λογότυπα, κείμενα, design, λογισμικό) προστατεύεται από δικαιώματα πνευματικής ιδιοκτησίας και δεν επιτρέπεται η αναπαραγωγή χωρίς έγγραφη άδεια.
          </li>
          <li>
            <b>Πληρωμές και Συνδρομές (αν ισχύει):</b>
            <ul>
              <li>Οι τιμές αναγράφονται σε [νόμισμα].</li>
              <li>Οι πληρωμές είναι μη επιστρέψιμες, εκτός αν προβλέπεται διαφορετικά από τη νομοθεσία.</li>
              <li>Η Πλατφόρμα μπορεί να τροποποιεί τις τιμές με προηγούμενη ενημέρωση.</li>
            </ul>
          </li>
          <li>
            <b>Περιορισμός Ευθύνης:</b> Η Πλατφόρμα παρέχεται “ως έχει”. Δεν εγγυόμαστε αδιάλειπτη ή χωρίς σφάλματα λειτουργία. Στο μέγιστο βαθμό που επιτρέπει ο νόμος, δεν φέρουμε ευθύνη για έμμεσες ή αποθετικές ζημίες.
          </li>
          <li>
            <b>Προστασία Δεδομένων:</b> Η επεξεργασία προσωπικών δεδομένων γίνεται σύμφωνα με την Πολιτική Απορρήτου της Πλατφόρμας.
          </li>
          <li>
            <b>Τροποποίηση Όρων:</b> Διατηρούμε το δικαίωμα αλλαγής των Όρων ανά πάσα στιγμή. Η συνέχιση της χρήσης μετά από αλλαγές σημαίνει αποδοχή τους.
          </li>
          <li>
            <b>Τερματισμός:</b> Μπορούμε να διακόψουμε ή να περιορίσουμε την πρόσβαση χρήστη χωρίς προειδοποίηση αν παραβιάζει τους Όρους.
          </li>
          <li>
            <b>Εφαρμοστέο Δίκαιο:</b> Οι παρόντες Όροι διέπονται από το δίκαιο της Ελλάδας και κάθε διαφορά υπάγεται στα αρμόδια δικαστήρια της.
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpSupport",
};
</script>

<style scoped>
    li{
        margin-bottom: 15px;
    }
</style>
